import { LearningObjectStatus } from "../../enums/learning-object-status.enum";

export const loStatusName = (status: LearningObjectStatus) => {
    switch (status) {
        case LearningObjectStatus.inUse:
            return "In Use";
        case LearningObjectStatus.idle:
            return "Idle";
        case LearningObjectStatus.converting:
            return "Converting";
        case LearningObjectStatus.recognizing:
            return "Recognizing";
        case LearningObjectStatus.transcribing:
            return "Transcribing";
        case LearningObjectStatus.error:
            return "Error";
        case LearningObjectStatus.waitingForDownload:
            return "Waiting for download";
        case LearningObjectStatus.waitingForRecognition:
            return "Waiting for recognition";
    }
};
